import React from 'react'
import Container from '../../Container/Container'
import Header from '../Header/Header'

function Blogs() {
  return (
    <Container>
      <div>
      <div>
        <Header/>
      </div>
      <h2>
        Blogs
      </h2>
    </div>
    </Container>
  )
}

export default Blogs
